<template>
  <b-row v-if="options && options.length">
    <b-col
      v-for="(option, index) in options"
      :lg="grouped ? 12 : lg"
      :md="grouped ? 12 : md"
      :sm="grouped ? 12 : sm"
      class="mb-3"
      :key="index"
    >
      <template v-if="grouped">
        <div class="display-4 font-2xl mb-3">{{ option[textField] }}</div>

        <b-row v-if="option.options && option.options.length">
          <b-col
            v-for="(subOption, subIndex) in option.options"
            :lg="lg"
            :md="md"
            :sm="sm"
            class="mb-3"
            :key="subIndex"
          >
            <b-button
              @click="onSelect(subOption[valueField] || null)"
              :variant="
                current === subOption[valueField]
                  ? activeVariant
                  : defaultVariant
              "
              size="sm"
              block
              :class="['py-2', 'px-2', 'h-100', 'text-left']"
            >
              <i
                :class="[
                  'far',
                  'fa-' + (subOption[iconField] || null),
                  'font-2xl'
                ]"
              ></i>
              <span
                class="pl-3 text-uppercase d-inline-block position-relative"
                style="top: -5px;"
              >
                {{ subOption[textField] }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-button
          v-if="option.text === 'Add customer'"
          size="sm"
          :class="['py-2', 'px-2', 'h-100', 'text-left']"
          block
          :variant="'success'"
          @click="onAddClick"
        >
          <i :class="['far', 'fa-plus', 'font-2xl']"></i>
          <span
            class="pl-3 text-uppercase d-inline-block position-relative"
            style="top: -5px;"
          >
            {{ option.text }}
          </span>
        </b-button>
        <b-button
          v-else
          @click="onSelect(option[valueField] || null)"
          :variant="
            current === option[valueField] ? activeVariant : defaultVariant
          "
          size="sm"
          block
          :class="['py-2', 'px-2', 'h-100', 'text-left']"
        >
          <b-row class="align-items-center">
            <b-col cols="1">
              <i
                :class="[
                  'far',
                  'fa-' + (option[iconField] || null),
                  'font-2xl'
                ]"
              ></i>
            </b-col>
            <b-col>
              <span
                class="pl-2 text-uppercase d-inline-block position-relative"
                style="top: -2px;"
                v-html="option[textField]"
              ></span>
            </b-col>
          </b-row>
        </b-button>
      </template>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "CustomFormRadioGroup",
  props: {
    value: {
      default() {
        return null;
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    textField: {
      type: String,
      default() {
        return "text";
      }
    },
    valueField: {
      type: String,
      default() {
        return "value";
      }
    },
    iconField: {
      type: String,
      default() {
        return "icon";
      }
    },
    state: {
      type: Boolean,
      default() {
        return null;
      }
    },
    grouped: {
      type: Boolean,
      default() {
        return false;
      }
    },
    iconField: {
      type: String,
      default() {
        return "icon";
      }
    },
    lg: {
      type: Number,
      default() {
        return 3;
      }
    },
    md: {
      type: Number,
      default() {
        return 3;
      }
    },
    sm: {
      type: Number,
      default() {
        return 6;
      }
    }
  },
  data() {
    return {
      activeVariant: "primary",
      defaultVariant: "dark",
      current: null
    };
  },
  methods: {
    onSelect(v) {
      this.current = v;
      this.$emit("change", this.current);
    },
    onAddClick() {
      this.$router.push("/customer/add");
    }
  },
  watch: {
    current: {
      handler(v) {
        this.$emit("input", v);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.current = this.value;
  }
};
</script>
